import { useEffect } from 'react';
import { EventEmitterService } from 'js/services/eventEmitter.service';

export const ANY_EVENT = '*';

export class PushDispatcher extends EventEmitterService {
    trigger(eventName, ...args) {
        if (this.events[ANY_EVENT]) {
            super.trigger(ANY_EVENT, ...args);
        }

        super.trigger(eventName, ...args);
    }
}

const pushDispatcher = new PushDispatcher();

export default pushDispatcher;

/**
 * Subscribe to pushes from server
 * @param {String|Number|Array<String>|Array<Number>} pushIds
 * @param {function(Object): Function} callback
 * @param {Object} [params] - params object for callback
 * @param {Array} [dependencies] - explicit hook dependencies
 */
export const usePushSubscription = (pushIds, callback, params = {}, dependencies = []) => {
    const pushIdsDependency = Array.isArray(pushIds) ? pushIds : [pushIds];
    const paramsDependencies = Object.values(params);

    useEffect(() => {
        const pushHandler = callback(params);
        pushDispatcher.on(pushIds, pushHandler);

        return () => pushDispatcher.off(pushIds, pushHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...pushIdsDependency, callback, ...paramsDependencies, ...dependencies]);
};
